import { Box, Collapse, Stack, Tooltip, useColorModeValue, Text, VStack } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';

type BadgeValueFieldProps = {
    label: string;
    value: string | number;
    icon?: React.ReactNode;
    tooltipText?: string;
    wrapperStyle?: React.CSSProperties;
    smallVariant?: boolean;
    compactView?: boolean;
    maxWidth?: string;
    canCopy?: boolean;
    children: React.ReactNode;
};

export const BadgeValueField: React.FC<BadgeValueFieldProps> = ({
    label,
    value,
    icon,
    tooltipText,
    wrapperStyle,
    smallVariant = false,
    maxWidth = '200px',
    compactView = false,
    children,
}) => {
    const hoverBackground = useColorModeValue('gray.100', 'gray.700');
    const [isCompact, setIsCompact] = useState(compactView);

    useEffect(() => {
        setIsCompact(compactView);
    }, [compactView]);

    return (
        <Tooltip label={tooltipText ?? label + ': ' + value}>
            <Stack
                direction={'row'}
                style={wrapperStyle}
                justify={'left'}
                align={'start'}
                gap={1}
                _hover={{ backgroundColor: hoverBackground }}
                borderRadius={'xl'}
                p={1}
                transition="all 0.3s ease"
            >
                <Box pt={1}>{icon}</Box>
                <VStack justify={'left'} align={'start'} gap={isCompact ? 0 : 1} transition="all 0.3s ease">
                    <Collapse animateOpacity in={!isCompact}>
                        <Text
                            align={'center'}
                            maxWidth={maxWidth}
                            overflow="hidden"
                            whiteSpace="nowrap"
                            textOverflow="ellipsis"
                            fontSize={smallVariant ? 'md' : 'lg'}
                            fontWeight={'600'}
                            transition="all 0.3s ease"
                        >
                            {label}
                        </Text>
                    </Collapse>
                    {children}
                </VStack>
            </Stack>
        </Tooltip>
    );
};
